import { Button } from "@9amhealth/shared";
import { FC } from "react";
import { TrashIcon } from "src/ui/assets/icons/TrashIcon";
import { ParsedObservationData } from "src/lib/fhir";
import { DELETABLE_LAB_CODES } from "./DeleteLabByCode.constant";
import { LoincCodingCode } from "src/constants/fhir";
import { PopupDialogTrigger } from "molecule/popupDialog/PopupDialogTrigger";
import { PopupDialogTriggerButton } from "molecule/popupDialog/PopupDialogTriggerButton";
import { getSupportedUserLocale } from "src/lib/i18next";
import Translate from "components/Translate/Translate";
import { PopupDialog } from "molecule/popupDialog/PopupDialog";

export const DeleteLabByCode: FC<{
  data: ParsedObservationData;
  unitText: string;
}> = ({ data, unitText }) => {
  const { code, value, date } = data;

  const deleteFn = DELETABLE_LAB_CODES[code as LoincCodingCode];
  if (!deleteFn) {
    return null;
  }

  return (
    <PopupDialogTrigger>
      <PopupDialogTriggerButton>
        <TrashIcon />
      </PopupDialogTriggerButton>
      <PopupDialog
        title={<Translate msg={"deleteLabByCode.title"} />}
        actions={
          <>
            <Button slot={"close"} theme="simple" hideArrow>
              <Translate msg={"cancel"} />
            </Button>
            <Button
              slot={"close"}
              theme="danger"
              hideArrow
              onPress={() => void deleteFn(data)}
            >
              <Translate msg={"delete"} />
            </Button>
          </>
        }
      >
        <Translate
          msg={"deleteLabByCode.confirmation"}
          variables={{
            value,
            unitText,
            date: date.toDate().toLocaleString(getSupportedUserLocale(), {
              month: "short",
              day: "numeric"
            })
          }}
        />
      </PopupDialog>
    </PopupDialogTrigger>
  );
};
